import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrIcalFeedStatus.ts
var t = () => e("icalFeedStatus");
//#endregion
export { t as useTrIcalFeedStatus };
